import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import DetailsWithPhoto from 'components/shared/DetailsWithPhoto'

export default function Description({ term }) {
  const {
    attributes: { description, image },
  } = term
  return (
    <Row className="page-wrapper">
      <Col
        md={16}
        xs={24}
        style={{
          fontWeight: 'normal',
          fontSize: '16px',
          lineHeight: '22px',
        }}
      >
        <DetailsWithPhoto details={description} image={image} />
      </Col>
      <Col span={6}>
        {/* <Row>
          <Col span={24}>
            <Card
              title="Related Terms"
              bordered={false}
              style={{ float: 'right' }}
              headStyle={{
                background: '#E6F7FF',
                color: '#2F80ED'
              }}
            >
              <p>Financial Statements</p>
              <p>Financial Ratios</p>
              <p>Current Ratio Calculator</p>
              <p>Quick Ratio Calculator</p>
              <p>Others</p>
            </Card>
          </Col>
        </Row> */}
      </Col>
    </Row>
  )
}

Description.propTypes = {
  term: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
}
